import {
  ArrowBack as ArrowBackIcon,
  Refresh as RefreshIcon,
} from "@mui/icons-material";
import { Box, Typography, IconButton, Breadcrumbs, Link } from "@mui/material";
import React from "react";
import { useParams, useNavigate } from "react-router";

import CustomTabs, { TabConfig } from "components/common/CustomTabs";
import HeightTabContent from "components/features/patient/bodyMeasurements/HeightTabContent";
import BodyShapeTabContent from "components/features/patient/bodyMeasurements/BodyShapeTabContent";
import BodyCompositionTabContent from "components/features/patient/bodyMeasurements/BodyCompositionTabContent";
import { DashboardLayout } from "components/layouts";
import { EPath } from "constants/path";

const BodyMeasurementsHistoryPage: React.FC = () => {
  const { patientId } = useParams<{ patientId: string }>();
  const navigate = useNavigate();

  if (!patientId)
    return (
      <Box sx={{ p: 2 }}>
        <Typography>No patient found</Typography>
      </Box>
    );

  const tabs: TabConfig[] = [
    {
      label: "Height",
      content: <HeightTabContent patientId={patientId} />,
    },
    {
      label: "Body Shape",
      content: <BodyShapeTabContent patientId={patientId} />,
    },
    {
      label: "Body Composition",
      content: <BodyCompositionTabContent patientId={patientId} />,
    },
  ];

  return (
    <DashboardLayout title="Body Measurements">
      <Box sx={{ p: 2 }}>
        {/* Breadcrumbs */}
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            mb: 2,
          }}
        >
          <Breadcrumbs>
            <Link
              color="inherit"
              component="button"
              onClick={() => navigate(EPath.HOME)}
            >
              Dashboard
            </Link>
            <Link
              color="inherit"
              component="button"
              onClick={() => navigate(EPath.PATIENT_MANAGEMENT)}
            >
              Patient Management
            </Link>
            <Link
              color="inherit"
              component="button"
              onClick={() =>
                navigate(EPath.PATIENT_DETAIL.replace(":patientId", patientId))
              }
            >
              Patient Details
            </Link>
            <Typography color="text.primary">Body Measurements</Typography>
          </Breadcrumbs>

          <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
            <IconButton
              onClick={() => navigate(-1)}
              size="small"
              sx={{ color: "text.secondary" }}
            >
              <ArrowBackIcon />
            </IconButton>
            <IconButton
              onClick={() => window.location.reload()}
              size="small"
              sx={{ color: "text.secondary" }}
            >
              <RefreshIcon />
            </IconButton>
          </Box>
        </Box>

        <Box sx={{ mt: 2, height: "calc(100vh - 200px)", minHeight: "600px" }}>
          <CustomTabs tabs={tabs} distributeEvenly />
        </Box>
      </Box>
    </DashboardLayout>
  );
};

export default BodyMeasurementsHistoryPage;
